import { useQuery } from "@tanstack/react-query";
import { getUserData, getUserStatistics } from "../../api";

export const useGetUserStatistics = () => {
    const query = useQuery({
      queryKey: ["statistics"],
      queryFn: () => getUserStatistics(),
    });
    return {
      isLoading: query.isPending,
      isSuccess: query.isSuccess,
      isError: query.isError,
      data: query.data,
      refetch: query.refetch,
    };
  };

export const useGetUserData = () => {
    const query = useQuery({
      queryKey: ["user"],
      queryFn: () => getUserData(),
    });
    return {
      isLoading: query.isPending,
      isSuccess: query.isSuccess,
      isError: query.isError,
      data: query.data,
      refetch: query.refetch,
    };
  };